import script from "./ImageGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageGallery.vue?vue&type=script&setup=true&lang=js"

import "./ImageGallery.vue?vue&type=style&index=0&id=2a8bf814&lang=css"

const __exports__ = script;

export default __exports__